/** Column flex layout for current assets table (header + rows). */
export const currentAssetsLogoColumnProps = {
    width: 40 as const,
    flexShrink: 0,
    minWidth: 40,
    alignItems: 'center' as const,
};

export const currentAssetsNameColumnProps = {
    flex: 0.95,
    flexBasis: 0,
    minWidth: 88,
    width: '100%' as const,
};

export const currentAssetsInstitutionColumnProps = {
    flex: 0.85,
    flexBasis: 0,
    minWidth: 80,
    width: '100%' as const,
};

export const currentAssetsOwnershipColumnProps = {
    flex: 0.75,
    flexBasis: 0,
    minWidth: 72,
    width: '100%' as const,
};

export const currentAssetsTypeColumnProps = {
    flex: 0.65,
    flexBasis: 0,
    minWidth: 80,
    width: '100%' as const,
};

export const currentAssetsHolisticCategoryColumnProps = {
    flex: 0.65,
    flexBasis: 0,
    minWidth: 76,
    width: '100%' as const,
};

export const currentAssetsLastFourColumnProps = {
    flex: 0.42,
    flexBasis: 0,
    minWidth: 48,
    width: '100%' as const,
};

export const currentAssetsBalanceColumnProps = {
    flex: 0.72,
    flexBasis: 0,
    minWidth: 88,
    width: '100%' as const,
};

/** Spinner + institution/link icon + ⋯ menu — must match header + rows or columns shift. */
export const CURRENT_ASSETS_ACTIONS_OUTER_WIDTH = 108;

/** Matches Smoothie `IconButton` (regular) width so the menu slot does not reflow when swapping to a spinner. */
export const CURRENT_ASSETS_MENU_SLOT_SIZE = 40;
